(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('agent-request', {
                parent: 'entity',
                url: '/agent-request?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.agentRequest.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/agent-request/agent-requests.html',
                        controller: 'AgentRequestController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('agentRequest');
                        $translatePartialLoader.addPart('agentRequestType');
                        $translatePartialLoader.addPart('agentRequestStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('agent-request-detail', {
                parent: 'entity',
                url: '/agent-request/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.agentRequest.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/agent-request/agent-request-detail.html',
                        controller: 'AgentRequestDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('agentRequest');
                        $translatePartialLoader.addPart('agentRequestType');
                        $translatePartialLoader.addPart('agentRequestStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'AgentRequest', function ($stateParams, AgentRequest) {
                        return AgentRequest.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('agent-request.new', {
                parent: 'agent-request',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-request/agent-request-dialog.html',
                        controller: 'AgentRequestDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    agentRequestType: null,
                                    createDate: null,
                                    requestMessage: null,
                                    suggestedCommision: null,
                                    replyDate: null,
                                    replyMessage: null,
                                    status: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('agent-request', null, {reload: true});
                    }, function () {
                        $state.go('agent-request');
                    });
                }]
            })
            .state('agent-request.edit', {
                parent: 'agent-request',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-request/agent-request-dialog.html',
                        controller: 'AgentRequestDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['AgentRequest', function (AgentRequest) {
                                return AgentRequest.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('agent-request', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('agent-request.delete', {
                parent: 'agent-request',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-request/agent-request-delete-dialog.html',
                        controller: 'AgentRequestDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['AgentRequest', function (AgentRequest) {
                                return AgentRequest.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('agent-request', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
